import { Components, Theme } from "@mui/material";
import { CustomPalette } from "./palette";

const boxShadow1 = "0px 3px 1px -4px rgba(0,0,0,0.2), 0px 1px 5px 0px rgba(0,0,0,0.12)";

export default {
  MuiButton: {
    variants: [
      {
        props: { variant: "contained" },
        style: {
          color: "#fff",
          textTransform: "none",
        },
      },
      {
        props: { variant: "contained", color: "secondary" },
        style: {
          color: CustomPalette.secondary.main,
          backgroundColor: "white",
          textTransform: "none",
        },
      },
      {
        props: { variant: "outlined" },
        style: {
          textTransform: "none",
        },
      },
      {
        props: { variant: "transparent" },
        style: {
          boxShadow: boxShadow1,
          color: CustomPalette.primary.main,
          textTransform: "none",
        },
      },
      {
        props: { variant: "transparent", color: "secondary" },
        style: {
          color: CustomPalette.secondary.main
        },
      },
    ],
    styleOverrides: {
      root: {
        borderRadius: 24,
        padding: "6px 24px"
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {},
    variants: [
      {
        props: { color: "secondary" },
        style: {
          backgroundColor: "white",
          boxShadow: boxShadow1,
          color: CustomPalette.black.main
        },
      },
      {
        props: { color: "success" },
        style: {
          backgroundColor: CustomPalette.success.main,
          boxShadow: boxShadow1,
          color: "white",
          ':hover': {
            backgroundColor: CustomPalette.success.dark,
          }
        },
      },
    ]
  },
  MuiFab: {
    styleOverrides: {
      root: {
        boxShadow: boxShadow1,
      },
    },
    variants: [
      {
        props: { color: "secondary" },
        style: {
          backgroundColor: "white",
          color: CustomPalette.black.main
        },
      },
      {
        props: { color: "secondary" },
        style: {
          backgroundColor: "white",
          color: CustomPalette.black.main
        },
      },
    ]
  }
} as Components<Omit<Theme, "components">>;